import { useEffect, useRef, useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Close, Download } from '../icons/icons';
import axios from 'axios'
import { Loader } from './loader';
import { BrowserDetail } from '../shared/utility';

const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`
pdfjs.GlobalWorkerOptions.workerSrc = url

export default function InvoicePreviewer(props: any) {

    const [numPages, setNumPages] = useState(0);
    const [theme, setTheme] = useState('posbill');
    const [pageNumber, setPageNumber] = useState(1);
    // const [showPageControls, setShowPageControls] = useState(false);
    const [fileUrl, setFileUrl] = useState('');
    const [showPreview, setShowPreview] = useState(false);
    const [showPreviewWrapper, setShowPreviewWrapper] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({ isError: false, message: '' })
    // var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;

    let downloadRef: any = useRef(null);

    useEffect(() => {
        if (props.match.params.hasOwnProperty('platform')) {
            setTheme(props.match.params.platform.toLowerCase())
        }
    }, [props.match.params])

    useEffect(() => {
        getURL(props.match.params.id);
    }, [props.match.params.id])

    const getURL = (id: string) => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_BASE_URL}/receipt/find`, { id })
            .then(res => {
                setLoading(false);
                if (res.data.isError) {
                    setError({ isError: true, message: 'Receipt not available yet.' })
                } else {
                    setFileUrl(res.data.data.url);
                    setError({ isError: false, message: '' })
                }
            })
            .catch(err => {
                setLoading(false);
                console.log("Error : ", err);
            })
    }

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    }

    const handlePreview = () => {
        setNumPages(0);
        if (!!fileUrl) {
            if (showPreviewWrapper) {
                setShowPreview(false);
                setTimeout(() => {
                    setShowPreviewWrapper(false);
                }, 300);
            } else {
                setShowPreviewWrapper(true)
                setTimeout(() => {
                    setShowPreview(true)
                }, 100);
            }
        } else {
            setError({ isError: true, message: "File not found." })
        }
    }

    const handleDownload = () => {
        downloadRef.current.click()
    }
    const isDisabled = !fileUrl || error.isError;

    const isPreviewDisable = BrowserDetail().browserName === 'Safari';

    // const showPages = !error.isError && numPages > 0 && showPageControls;
    const showPages = !error.isError && numPages > 0;

    let pageProps: { height?: number, width?: number } = window.innerWidth > window.innerHeight ? { height: window.innerHeight } : { width: window.innerWidth };
    // let pageControllerPosition = window.innerWidth > window.innerHeight ? 'landscape' : (BrowserDetail().browserName === 'Safari' && BrowserDetail().majorVersion >= 15 ? 'portrait' : 'landscape');
    return (
        <div className="App">
            <header className="App-header">
                <div className="logo">Deine digitale Rechnung</div>
                {loading
                    ? <Loader />
                    : <>
                        {error.isError && <div className="error">{error.message}</div>}
                        <div className="btn-group">
                            <button onClick={() => !isPreviewDisable && handlePreview()} disabled={isDisabled || isPreviewDisable} className={`preview-btn ${(isDisabled || isPreviewDisable) ? 'disabled-btn' : ''}`}>
                                <svg viewBox="0 0 18 18" width="20px" height="30px"><path d="M17.707 16.288l-3.43-3.43a4.47 4.47 0 1 0-1.418 1.42l3.43 3.43a1 1 0 1 0 1.417-1.42zM8 10.478a2.48 2.48 0 1 1 2.48 2.48A2.48 2.48 0 0 1 8 10.48z"></path><path d="M10 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6.1a6.53 6.53 0 0 1-2.587-3H3a1 1 0 0 1 0-2h1.034C4.02 10.825 4 10.654 4 10.478A6.447 6.447 0 0 1 4.177 9H3a1 1 0 0 1 0-2h2.022a6.526 6.526 0 0 1 2.014-2H3a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1 .913.913 0 0 1-.038.187A6.437 6.437 0 0 1 10.478 4c.176 0 .348.013.52.026V1A1 1 0 0 0 10 0z"></path></svg>
                                Anzeigen
                            </button>
                            <a href={fileUrl} download ref={downloadRef} hidden>Herunterladen</a>
                            <button disabled={isDisabled} className={`download-btn ${isDisabled ? 'disabled-btn' : ''}`} onClick={handleDownload}>
                                <svg viewBox="0 0 490 490" width="20px" height="22px"><g><g><g><path d="M245,0c-9.5,0-17.2,7.7-17.2,17.2v331.2L169,289.6c-6.7-6.7-17.6-6.7-24.3,0s-6.7,17.6,0,24.3l88.1,88.1 c3.3,3.3,7.7,5,12.1,5c4.4,0,8.8-1.7,12.1-5l88.1-88.1c6.7-6.7,6.7-17.6,0-24.3c-6.7-6.7-17.6-6.7-24.3,0L262,348.4V17.1 C262.1,7.6,254.5,0,245,0z"></path><path d="M462.1,472.9v-99.7c0-9.5-7.7-17.2-17.2-17.2s-17.2,7.7-17.2,17.2v82.6H62.2v-82.6c0-9.5-7.7-17.2-17.1-17.2 s-17.2,7.7-17.2,17.2v99.7c0,9.5,7.7,17.1,17.2,17.1h399.8C454.4,490,462.1,482.4,462.1,472.9z"></path></g></g></g></svg>
                                Herunterladen
                            </button>
                        </div>
                    </>}
            </header>
            {showPreviewWrapper && <div className={`body ${showPreview ? 'preview-invoice' : ''}`}>
                {!error.isError && <div className="download-button" onClick={handleDownload}><Download /></div>}
                <div className="close-button" onClick={handlePreview}><Close /></div>
                <div className="document-wrapper">
                    {/* <div dangerouslySetInnerHTML={{ __html: `<iframe src='${fileUrl}' height="100%" width="100%"/>` }} />; */}
                    <Document
                        file={fileUrl}
                        error={<div className="error">PDF konnte nicht geladen werden.</div>}
                        loading={<Loader />}
                        onLoadError={(e) => setError({ isError: true, message: e.message })}
                        onLoadSuccess={onDocumentLoadSuccess}
                        renderMode={"svg"}
                    >
                        <TransformWrapper>
                            <TransformComponent>
                                <Page pageNumber={pageNumber} {...pageProps} />
                            </TransformComponent>
                        </TransformWrapper>
                    </Document>
                    {
                        showPages && (<div id="page-controls" className="page-controller">
                            {numPages > 1 && <button disabled={numPages === 1 || pageNumber === 1} onClick={() => setPageNumber(pageNumber - 1)}>&lt;</button>}
                            <p>{pageNumber} &#47; {numPages}</p>
                            {numPages > 1 && <button disabled={numPages === 1 || pageNumber === numPages} onClick={() => setPageNumber(pageNumber + 1)}>&gt;</button>}
                        </div>)
                    }
                </div>
            </div>}
            <div className="footer-links">
                <a href="https://www.posbill.com/impressum" target="_blank" rel="noreferrer">Impressum</a>
                <a href="https://www.posbill.com/datenschutz" target="_blank" rel="noreferrer">Datenschutz</a>
            </div>
        </div >
        
    );
}